var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatarProvider(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "cv26kto7ca",
    cx: 24.5,
    cy: 24.5,
    r: 24.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-161 -297) translate(7 261) translate(154 36)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "br1rryr4rb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cv26kto7ca"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#4A657B",
    xlinkHref: "#cv26kto7ca"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#br1rryr4rb)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.533 19.58h-6.066c-6.793 0-12.32 5.63-12.32 12.55v4.587c0 .545.434.987.969.987h28.768c.536 0 .97-.442.97-.987V32.13c0-6.921-5.528-12.552-12.32-12.552zm2.696 8.75c.74 0 1.34.614 1.34 1.367 0 .754-.6 1.367-1.34 1.367-.74 0-1.341-.613-1.341-1.367 0-.753.601-1.366 1.34-1.366zm7.687 7.4H2.084v-3.6c0-4.398 2.65-8.177 6.408-9.77v3.928H7.97c-1.553 0-2.816 1.288-2.816 2.87v2.893c0 .545.433.987.968.987.535 0 .97-.442.97-.987v-2.893c0-.494.394-.896.878-.896h2.91c.486 0 .88.402.88.896v2.893c0 .545.434.987.969.987.535 0 .969-.442.969-.987v-2.893c0-1.582-1.264-2.87-2.817-2.87h-.45v-4.53c.659-.133 1.34-.205 2.036-.205h6.067c.589 0 1.164.053 1.727.149v4.803c-1.337.422-2.31 1.694-2.31 3.192 0 1.842 1.47 3.34 3.278 3.34s3.279-1.498 3.279-3.34c0-1.498-.974-2.77-2.31-3.192v-4.27c3.922 1.513 6.718 5.377 6.718 9.895v3.6zM16.731 3.521L14.794 3.521 14.794 4.744 13.594 4.744 13.594 6.718 14.794 6.718 14.794 7.94 16.731 7.94 16.731 6.718 17.931 6.718 17.931 4.744 16.731 4.744z",
    transform: "translate(10 12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 18.003c4.374 0 7.933-3.625 7.933-8.082V1.184c0-.545-.434-.987-.97-.987H8.537c-.535 0-.969.442-.969.987v8.737c0 4.457 3.559 8.082 7.933 8.082zM9.505 2.171h11.99v6.763H9.505V2.171zm11.912 8.737c-.464 2.9-2.941 5.121-5.917 5.121s-5.453-2.22-5.917-5.12h11.834z",
    transform: "translate(10 12)"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarProvider);
export default __webpack_public_path__ + "static/media/avatar-provider.0f1483a075624e38acef364e5a9fbda8.svg";
export { ForwardRef as ReactComponent };